class StrtingService {
    

    getLast4 = (string) => {
        return string.slice(-4);
    }
}

export const stringService = new StrtingService();